import { render } from "./InputSelectNewTheme.vue?vue&type=template&id=5b75f80a&scoped=true"
import script from "./InputSelectNewTheme.vue?vue&type=script&lang=js"
export * from "./InputSelectNewTheme.vue?vue&type=script&lang=js"

import "./InputSelectNewTheme.vue?vue&type=style&index=0&id=5b75f80a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b75f80a"]])

export default __exports__